import { render, staticRenderFns } from "./CalssProblemStatistics.vue?vue&type=template&id=13c941bc&scoped=true&"
import script from "./CalssProblemStatistics.vue?vue&type=script&lang=js&"
export * from "./CalssProblemStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CalssProblemStatistics.vue?vue&type=style&index=0&id=13c941bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c941bc",
  null
  
)

export default component.exports